<template>
  <div v-if="isVisible" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-[7vh] text-white z-10" @click="handleBackdropClick">
    <div class="p-6 bg-gray-900 rounded-lg shadow-lg overflow-auto max-h-[min(85vh,40rem)] w-96 sm:w-[28rem]" @click.stop>
      <header class="flex justify-between items-center text-2xl">
        <h2>{{heading}}</h2>
        <button @click="closeModal" class="text-3xl leading-none px-2 text-gray-400 hover:text-white" aria-label="Close">&times;</button>
      </header>
      <main class="mt-4">
        <slot>Default content</slot>
      </main>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['update:isVisible']);
defineProps({
  isVisible: Boolean,
  heading: String
})

const handleBackdropClick = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const closeModal = () => {
  emit('update:isVisible', false);
};
</script>
